
import AdminNavBarMain from "./AdminNavBarMain";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState, useCallback, useRef } from 'react'
import { Link, useParams, useSearchParams } from 'react-router-dom';
import Lightbox from "./Lightbox";
import { LOADER, LOADING, HIDING } from "../Constant";
import { GlobalLoader } from "../helpers";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css"; // or any theme
import { Modal } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { toast } from "react-toastify";
import axios from "axios";
import { base_url, COMPLIANCE_APPROVED } from "../utilities";
import { EKYC_BASE_URL } from "../config/environment";

function ArtifactGrid({ entries, data, onOpenViewer }) {
    const labelMap = {
        idFront: 'ID Front',
        idBack: 'ID Back',
        id2Front: 'Second ID Front',
        id2Back: 'Second ID Back',
        selfieImage: 'Selfie',
        selfieVideo: 'Selfie Video',
        signatureImage: 'Signature (from ID)',
        idHeadshot: 'ID Headshot',
        bankStatement: 'Bank Statement',
        addressProof: 'Address Proof',
        livenessSessionImage: 'Liveness Session Image',
    }
    const isImage = (name) => /\.(png|jpg|jpeg|gif|webp|bmp)$/i.test(name || '')
    const isVideo = (name) => /\.(mp4|webm|ogg)$/i.test(name || '')
    const getName = (key) => data?.artifacts?.[key] || key

    return (
        <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))' }}>
            {entries.map(([key, url]) => {
                const name = getName(key)
                const label = labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, (char) => char.toUpperCase())
                const href = artifactUrl(url)
                if (isImage(name)) {
                    return (
                        <div key={key}>
                            <div className="muted">{label}</div>
                            <img className="thumb" src={href} alt={label} style={{ cursor: 'pointer' }} onClick={() => onOpenViewer({ open: true, src: href, title: label })} />
                            <div className="muted" style={{ maxWidth: 240, wordBreak: 'break-all', marginTop: 6 }}>
                                {name}
                            </div>
                        </div>
                    )
                }
                if (isVideo(name)) {
                    return (
                        <div key={key}>
                            <div className="muted">{label}</div>
                            <video src={href} controls style={{ width: '100%', borderRadius: 8, border: '1px solid var(--border)' }} />
                            <div className="muted" style={{ maxWidth: 240, wordBreak: 'break-all', marginTop: 6 }}>
                                {name}
                            </div>
                        </div>
                    )
                }
                return (
                    <div key={key}>
                        <div className="muted">{label}</div>
                        <a className="btn btn-secondary" href={href} target="_blank" rel="noreferrer">
                            Open
                        </a>
                        <div className="muted" style={{ maxWidth: 240, wordBreak: 'break-all', marginTop: 6 }}>
                            {name}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}






function EyeIcon() {
    return (
        <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
            <path
                d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle
                cx="12"
                cy="12"
                r="3"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
            />
        </svg>
    )
}

function riskBandClass(band) {
    if (band === 'High') return 'tag tag-danger'
    if (band === 'Medium') return 'tag tag-warn'
    return 'tag tag-success'
}

function formatSavedAt(value) {
    if (!value) return 'Not saved yet'
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return value
    return date.toLocaleString()
}




const EKYCDetailsView = () => {

    const location = useLocation();
    const fileInputRef = useRef(null);

    const { investorId, investor_kyc_id } = useParams();



    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const kycStatus = searchParams.get("status");




    const [applicationId, setApplicationId] = useState(null);

    const [viewer, setViewer] = useState({ open: false, src: '', title: '' })






    const [schema, setSchema] = useState(null)

    const [answers, setAnswers] = useState({})
    const [scores, setScores] = useState(null)
    const [updatedAt, setUpdatedAt] = useState(null)
    const [assessments, setAssessments] = useState([])
    const [activeAssessmentId, setActiveAssessmentId] = useState('')
    const [error, setError] = useState('')
    const [saving, setSaving] = useState(false)
    const [lookups, setLookups] = useState(null)
    const [lookupMeta, setLookupMeta] = useState(null)
    const [editFields, setEditFields] = useState({
        docFields: normalizeDocFields(),
        docFields2: normalizeDocFields(),
        addresses: normalizeAddresses(),
        extractedNames: normalizeExtractedNames(),
    })
    const [enableSweetAlert, setEnableSweetAlert] = useState(null);
    const [isChecked, setIsChecked] = useState(false);


    const getLoadingAlert = (type) => {
        if (type === LOADING) {
            setEnableSweetAlert(true);
        } else {
            setEnableSweetAlert(false);
        }
    };




    useEffect(() => {
        // Disable browser scroll restore
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual";
        }

        // Force scroll to top AFTER render
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 0);
    }, []);




    // Helper to flatten schema to 8 rows in the required order
    const pickQuestions = (schema) => {
        if (!schema) return []
        const order = ['pep', 'nationality', 'residence', 'customer_type', 'product_nature', 'onboarding', 'source_of_funds', 'sanctions']
        const map = {}
        schema.sections.forEach(sec => sec.questions.forEach(q => { map[q.id] = q }))
        return order.map(id => map[id]).filter(Boolean)
    }

    const rows = pickQuestions(schema)

    const isAllAnswered = rows.every(q => {
        const value = answers[q.id];
        return value !== undefined && value !== null && value !== '';
    });



    const SECTION_DOC1 = 'doc1'
    const SECTION_DOC2 = 'doc2'
    const SECTION_BANK = 'bank'
    const SECTION_ADDRESSES = 'addresses'

    const DOC_FIELD_CONFIG = [
        { key: 'givenName', label: 'Given Name' },
        { key: 'surname', label: 'Surname' },
        { key: 'dob', label: 'Date of Birth' },
        { key: 'idNumber', label: 'ID Number' },
        { key: 'expiry', label: 'Expiry' },
    ]


    const ADDRESS_CONFIG = [
        { key: 'bankStatement', label: 'Bank Statement (Primary)' },
        { key: 'id1', label: 'First ID' },
        { key: 'id2', label: 'Second ID' },
        { key: 'addressProof', label: 'Address Proof' },
    ]

    function normalizeDocFields(fields) {
        const source = fields || {}
        return {
            givenName: source.givenName || '',
            surname: source.surname || '',
            dob: source.dob || '',
            idNumber: source.idNumber || '',
            expiry: source.expiry || '',
        }
    }

    function normalizeAddresses(addresses) {
        const source = addresses || {}
        return {
            bankStatement: source.bankStatement || '',
            id1: source.id1 || '',
            id2: source.id2 || '',
            addressProof: source.addressProof || '',
        }
    }

    function normalizeExtractedNames(extractedNames) {
        const source = extractedNames || {}
        return {
            bankStatement: source.bankStatement || '',
        }
    }


    useEffect(() => {
        const loadAll = async () => {
            try {
                getLoadingAlert(LOADING);

                const [schemaData, lookupsData, metaData, riskData] = await Promise.all([
                    fetchRiskSchema(),
                    fetchRiskLookups(),
                    fetchRiskLookupsMeta(),
                    fetchRisk(applicationId)
                ]);

                setSchema(schemaData);
                setLookups(lookupsData);
                setLookupMeta(metaData);
                setAnswers(riskData?.answers || {});
                setScores(riskData?.scores || null);
                setUpdatedAt(riskData?.updatedAt || null);
                setAssessments(riskData?.assessments || []);
                setActiveAssessmentId(
                    riskData?.assessmentId || ''
                );

                calcLocal(
                    riskData?.answers || {},
                    lookupsData,
                    schemaData
                );


            } catch (err) {
                console.error(err);
            } finally {
                getLoadingAlert(HIDING);
            }
        };

        if (applicationId) {
            loadAll();
        }
    }, [applicationId]);

    function ScoreCell({ value }) {
        return <span className="tag tag-warn">{value ?? '-'}</span>
    }

    // Also compute via backend whenever answers change (confirmation/persistence)
    useEffect(() => {
        (async () => {
            if (!schema) return
            try {
                const s = await computeRiskPreview(answers)
                setScores(s)
            } catch (err) {
                console.error("Preview error", err);
            }
        })()
    }, [answers, schema]);

    const fetchRiskSchema = async () => {
        const base = EKYC_BASE_URL;

        const res = await fetch(`${base}/risk/schema`, {
            headers: { "Content-Type": "application/json" },
        });

        if (!res.ok) throw new Error("Schema fetch failed");

        return await res.json();
    };


    const fetchRiskLookups = async () => {
        const base = EKYC_BASE_URL;

        const res = await fetch(`${base}/risk/lookups`, {
            headers: { 'Content-Type': 'application/json' },
        });

        if (!res.ok) throw new Error("Lookups fetch failed");

        return await res.json();
    };

    const fetchRiskLookupsMeta = async () => {
        const base = EKYC_BASE_URL;

        const res = await fetch(`${base}/risk/lookups/meta`, {
            headers: { 'Content-Type': 'application/json' },
        });

        if (!res.ok) throw new Error("Meta fetch failed");

        return await res.json();
    };


    const fetchRisk = async (applicationId) => {
        const base = EKYC_BASE_URL;

        const res = await fetch(`${base}/ekyc/case/${applicationId}/risk`, {
            headers: {
                "Content-Type": "application/json"
            }
        });

        if (!res.ok) {
            throw new Error("Failed to fetch risk");
        }

        return await res.json();
    };


    const saveRisk = async (applicationId, answers) => {
        const base = EKYC_BASE_URL;

        const res = await fetch(`${base}/ekyc/case/${applicationId}/risk`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ answers })
        });

        if (!res.ok) {
            throw new Error("Failed to save risk");
        }

        return await res.json();
    };



    const computeRiskPreview = async (answers) => {
        const base = EKYC_BASE_URL;

        const res = await fetch(`${base}/risk/compute`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ answers })
        });

        if (!res.ok) {
            throw new Error("Preview failed");
        }

        return await res.json();
    };


    // Local immediate scoring to avoid perceived delay
    const bands = [
        { label: 'Low', min: 0, max: 30 },
        { label: 'Medium', min: 31, max: 59 },
        { label: 'High', min: 60, max: 999 },
    ]


    const calcLocal = (ans, lookupTables = lookups, schemaArg = schema) => {
        if (!schemaArg) return { total: 0, band: 'Low' }
        let total = 0
        const scCopy = JSON.parse(JSON.stringify(schemaArg))
        scCopy.sections.forEach(sec => {
            sec.questions.forEach(q => {
                let scv = 0
                const val = ans[q.id]
                if (q.type === 'country') {
                    const table = (lookupTables && lookupTables[q.lookup]) || {}
                    scv = (val && table[val] != null) ? table[val] : table.default || 0
                } else if (q.lookup && lookupTables && lookupTables[q.lookup]) {
                    const table = lookupTables[q.lookup]
                    scv = (val && table[val] != null) ? table[val] : table.default || 0
                } else {
                    const opt = (q.options || []).find(o => o.value === val)
                    scv = opt ? opt.score : 0
                }
                q._score = scv
                total += Number(scv || 0)
            })
        })

        setSchema(scCopy)
        const band = bands.find(b => total >= b.min && total <= b.max)?.label || 'Unknown'
        setScores({ total, band })
    }

    const onChange = (qid, val) => {
        setAnswers(prev => {
            const next = { ...prev, [qid]: val }
            calcLocal(next)
            return next
        })
        setActiveAssessmentId('')
    }

    const onSaveRisk = async () => {
        if (!applicationId) return;

        getLoadingAlert(LOADING);
        setSaving(true);

        try {
            const res = await saveRisk(applicationId, answers);

            setScores(res.scores);
            setUpdatedAt(res.updatedAt);
            setAssessments(res.assessments || []);
            setActiveAssessmentId(res.assessmentId || '');

            if (schema) calcLocal(res.answers || answers);

            setError('');

            if (res.message === "Assessment saved.") {
                toast.success("Risk Assessment submitted successfully");
            } else if (res.message === "No changes made.") {
                toast.info("No changes are made");
            } else {
                // Fallback message
                toast.success(res.message || "Risk Assessment submitted successfully");
            }
        } catch {
            toast.error("Failed to save");

            setError('Failed to save');
        } finally {
            getLoadingAlert(HIDING);
            setSaving(false);
        }
    };


    useEffect(() => {
        let cancelled = false;
        let timer;

        const init = async () => {
            getLoadingAlert(LOADING);

            try {
                const appData = await fetchApplicationDetails(investorId);

                if (!appData || cancelled) return;

                getLoadingAlert(HIDING);


                const appId = appData?.applicationId;
                if (!appId) return;

                setApplicationId(appId);

                await loadCase(appId);

            } catch (err) {
                getLoadingAlert(HIDING);

                if (!cancelled) {
                    console.error("Init error:", err);
                    toast.error("Failed to load application details");

                    setError("Failed to load application details");
                }
            }
        };

        const loadCase = async (appId) => {
            // getLoadingAlert(LOADING);

            try {
                const res = await fetchCase(appId);
                if (!res) return;

                // getLoadingAlert(HIDING);

                //  Apply condition here
                if (!cancelled) {
                    hydrateFromCase(res);
                }

                //  Apply condition for polling
                if (!cancelled && res.status === "processing") {
                    timer = setTimeout(() => {
                        loadCase(appId);
                    }, 1500);
                }


            } catch (err) {
                // getLoadingAlert(HIDING);

                if (!cancelled) {
                    console.error("Case load error:", err);
                    toast.error("Failed to load case");

                    setError("Failed to load case");
                }
            }
        };

        if (investorId) {
            init();
        }

        return () => {
            cancelled = true;
            if (timer) clearTimeout(timer);
        };

    }, [investorId]);






    const fetchCase = async (applicationId) => {
        // getLoadingAlert(LOADING);

        try {
            const base = EKYC_BASE_URL;

            const res = await fetch(`${base}/ekyc/case/${applicationId}`, {
                headers: {
                    "Content-Type": "application/json",
                }
            });


            if (!res.ok) {
                throw new Error("Failed to load case");
            }
            // getLoadingAlert(HIDING);

            return await res.json();
        } catch (error) {
            // getLoadingAlert(HIDING);

            console.error("Error fetching case:", error);
            throw error; // let caller (useEffect) handle UI error
        }
    };







    const fetchApplicationDetails = async (investorId) => {
        // getLoadingAlert(LOADING);

        try {
            const base = EKYC_BASE_URL;

            const res = await fetch(`${base}/ekyc/investor/${investorId}/latest`, {
                headers: {
                    "Content-Type": "application/json"
                }
            });

            if (!res.ok) {
                toast.error("Failed to load case");

                throw new Error("Failed to load case");
            }
            // getLoadingAlert(HIDING);

            const data = await res.json();
            return data;

        } catch (error) {
            // getLoadingAlert(HIDING);

            console.error("Error fetching application details:", error);


        }
    };

    function isSameObject(a, b) {
        return JSON.stringify(a) === JSON.stringify(b)
    }






    function compareNames(enteredFullName, extractedGiven, extractedSurname) {
        if (!enteredFullName || !extractedGiven || !extractedSurname) return null
        const entered = splitName(enteredFullName)
        const extracted = splitName(`${extractedGiven} ${extractedSurname}`)
        if (!entered.first || !entered.last || !extracted.first || !extracted.last) return null
        if (entered.last !== extracted.last) return false

        let firstMatches = false
        if (entered.first === extracted.first) {
            firstMatches = true
        } else {
            const minPrefix = 3
            firstMatches =
                (entered.first.length >= minPrefix && extracted.first.startsWith(entered.first)) ||
                (extracted.first.length >= minPrefix && entered.first.startsWith(extracted.first))
        }
        if (!firstMatches) return false

        if (entered.middles.length > 0) {
            for (const middle of entered.middles) {
                const match =
                    middle.length === 1
                        ? extracted.middles.some((item) => item && item[0] === middle)
                        : extracted.middles.some((item) => item.startsWith(middle))
                if (!match) return false
            }
        }

        return true
    }


    function normalizeName(value) {
        return String(value || '')
            .toUpperCase()
            .replace(/[^A-Z0-9]+/g, ' ')
            .trim()
    }

    function splitName(fullname) {
        const parts = normalizeName(fullname).split(' ').filter(Boolean)
        if (parts.length === 0) return { first: null, middles: [], last: null }
        if (parts.length === 1) return { first: parts[0], middles: [], last: null }
        if (parts.length === 2) return { first: parts[0], middles: [], last: parts[1] }
        return { first: parts[0], middles: parts.slice(1, -1), last: parts[parts.length - 1] }
    }



    function getVerificationRows(formFields, extractedNames, docFields, docFields2) {
        const userFullName = formFields?.fullName || ''
        const bankFullName = extractedNames?.bankStatement || ''
        return [
            {
                label: 'User vs 1st ID Name',
                value: compareNames(userFullName, docFields?.givenName, docFields?.surname),
            },
            {
                label: 'User vs 2nd ID Name',
                value: compareNames(userFullName, docFields2?.givenName, docFields2?.surname),
            },
            {
                label: 'Bank passbook Name vs 1st ID Name',
                value: compareNames(bankFullName, docFields?.givenName, docFields?.surname),
            },
            {
                label: 'Bank Passbook Name vs 2nd ID Name',
                value: compareNames(bankFullName, docFields2?.givenName, docFields2?.surname),
            },
        ]
    }

    const [data, setData] = useState(null)

    const [busy, setBusy] = useState(false)



    const apiProcessCase = async (applicationId) => {
        try {
            const base = EKYC_BASE_URL;
            getLoadingAlert(LOADING);

            const res = await fetch(`${base}/ekyc/case/${applicationId}/process`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                }
            });



            if (!res.ok) {
                throw new Error("Failed to trigger processing");
            }
            getLoadingAlert(HIDING);

            return await res.json();

        } catch (error) {
            getLoadingAlert(HIDING);

            console.error("Error triggering process:", error);
            throw error;
        }
    };





    const saveAdminFields = async (applicationId, payload) => {
        try {
            const base = EKYC_BASE_URL;
            getLoadingAlert(LOADING);

            const res = await fetch(`${base}/ekyc/case/${applicationId}/admin-fields`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });




            if (!res.ok) {
                throw new Error("Failed to load case");
            }

            getLoadingAlert(HIDING);

            return await res.json();

        } catch (error) {
            getLoadingAlert(HIDING);

            console.error("Error saving admin fields:", error);
            throw error;
        }
    };












    const [riskCompleted, setRiskCompleted] = useState(false);

    useEffect(() => {

        if (location.state?.reopenModal) {

            setRiskCompleted(
                location.state?.riskAssessmentCompleted || false
            );

        }

    }, [location.state]);

    const goToAdminDashboard = () => {
        navigate("/compliance", {
            state: {
                ...location.state,
                reopenModal: true,  // only when coming back
                investor_kyc_id,

            }
        });
    };


    const goToAdminDashboardSuccess = async () => {

        try {

            const res = await axios.post(
                base_url + "investor-master/get_all_approved_investors"
            );

            const allInvestors = res?.data?.data || [];

            // find updated investor
            const updatedInvestor = allInvestors.find(
                (item) =>
                    item?.kyc_forms?.some(
                        (form) =>
                            form?.investor_kyc_id === investor_kyc_id
                    )
            );



            // find matching kyc form
            const matchedKycForm = updatedInvestor?.kyc_forms?.find(
                (form) => form?.investor_kyc_id === investor_kyc_id
            );



            toast.success("Risk Assessment completed successfully");

            navigate("/compliance", {
                state: {
                    ...location.state,
                    reopenModal: true,
                    riskAssessmentCompleted:
                        matchedKycForm?.risk_assessment_completed || false
                }
            });

        } catch (error) {
            console.error(error);
        }
    };


    function SectionHeader({ title, editing, onEdit, onReset, onSave, saving, dirty }) {
        const handleClick = (fn) => (event) => {
            event.preventDefault()
            event.stopPropagation()
            if (typeof fn === 'function') fn()
        }

        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
                <h3 className="section-title">{title}</h3>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, position: 'relative', zIndex: 2, pointerEvents: 'auto', flexShrink: 0 }}>
                    {editing ? (
                        <>
                            <button type="button" className="btn btn-secondary" style={{ position: 'relative', zIndex: 2, pointerEvents: 'auto' }} onClick={handleClick(onReset)} disabled={saving}>
                                Reset
                            </button>
                            <button type="button" className="btn btn-primary" style={{ position: 'relative', zIndex: 2, pointerEvents: 'auto' }} onClick={handleClick(onSave)} disabled={saving}>
                                {saving ? 'Saving…' : 'Save'}
                            </button>
                        </>
                    ) : (
                        <button type="button" className="btn btn-secondary" style={{ position: 'relative', zIndex: 2, pointerEvents: 'auto' }} onClick={handleClick(onEdit)}>
                            Edit
                        </button>
                    )}
                </div>
            </div>
        )
    }








    const [savingEdits, setSavingEdits] = useState(false)
    const [saveMessage, setSaveMessage] = useState('')
    const [editingSection, setEditingSection] = useState('')
    const [lastSavedSection, setLastSavedSection] = useState('')

    const hydrateFromCase = (res) => {
        setData(res)
        setEditFields({
            docFields: normalizeDocFields(res?.docFields),
            docFields2: normalizeDocFields(res?.docFields2),
            addresses: normalizeAddresses(res?.addresses),
            extractedNames: normalizeExtractedNames(res?.extractedNames),
        })
        setEditingSection('')
        setLastSavedSection('')
    }



    const faceMatch = data?.faceMatch
    const liveness = data?.liveness
    const artifactUrls = data?.artifactUrls || {}
    const artifactEntries = Object.entries(artifactUrls)
    const generatedArtifactKeys = new Set(['idHeadshot', 'signatureImage', 'livenessSessionImage'])
    const uploadedArtifactEntries = artifactEntries.filter(([key]) => !generatedArtifactKeys.has(key))
    const generatedArtifactEntries = artifactEntries.filter(([key]) => generatedArtifactKeys.has(key))
    const hasSecondId = !!data?.docFields2
    const sectionInitialValues = {
        [SECTION_DOC1]: normalizeDocFields(data?.docFields),
        [SECTION_DOC2]: normalizeDocFields(data?.docFields2),
        [SECTION_BANK]: normalizeExtractedNames(data?.extractedNames),
        [SECTION_ADDRESSES]: normalizeAddresses(data?.addresses),
    }
    const sectionCurrentValues = {
        [SECTION_DOC1]: editFields.docFields,
        [SECTION_DOC2]: editFields.docFields2,
        [SECTION_BANK]: editFields.extractedNames,
        [SECTION_ADDRESSES]: editFields.addresses,
    }
    const sectionDirty = {
        [SECTION_DOC1]: !isSameObject(sectionCurrentValues[SECTION_DOC1], sectionInitialValues[SECTION_DOC1]),
        [SECTION_DOC2]: !isSameObject(sectionCurrentValues[SECTION_DOC2], sectionInitialValues[SECTION_DOC2]),
        [SECTION_BANK]: !isSameObject(sectionCurrentValues[SECTION_BANK], sectionInitialValues[SECTION_BANK]),
        [SECTION_ADDRESSES]: !isSameObject(sectionCurrentValues[SECTION_ADDRESSES], sectionInitialValues[SECTION_ADDRESSES]),
    }
    const hasAnyUnsavedChanges = Object.values(sectionDirty).some(Boolean)


    const getLabel = (key) => {
        switch (key) {
            case "nameUserVsId1":
                return "User vs 1st ID Name";
            case "nameUserVsId2":
                return "User vs 2nd ID Name";
            case "nameBankVsId1":
                return "Bank passbook Name vs 1st ID Name";
            case "nameBankVsId2":
                return "Bank Passbook Name vs 2nd ID Name";
            default:
                return key;
        }
    };

    const verificationRows1 = Object.entries(data?.verifications?.details || {}).map(
        ([key, value]) => ({
            key,
            label: getLabel(key),
            value: value.result,
            message: value.message
        })
    );


    const isSectionEditing = (section) => editingSection === section && lastSavedSection !== section



    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [nextSection, setNextSection] = useState(null);

    const [showProcessModal, setShowProcessModal] = useState(false);
    const [processMessage, setProcessMessage] = useState("");

    const enterEditMode = (section) => {
        if (editingSection && editingSection !== section && sectionDirty[editingSection]) {
            setNextSection(section);
            setShowConfirmModal(true);
            return;
        }

        setSaveMessage('');
        setLastSavedSection('');
        setEditingSection(section);
    };

    const resetSection = (section) => {

        setEditFields((prev) => ({
            ...prev,
            ...(section === SECTION_DOC1 ? { docFields: sectionInitialValues[SECTION_DOC1] } : {}),
            ...(section === SECTION_DOC2 ? { docFields2: sectionInitialValues[SECTION_DOC2] } : {}),
            ...(section === SECTION_BANK ? { extractedNames: sectionInitialValues[SECTION_BANK] } : {}),
            ...(section === SECTION_ADDRESSES ? { addresses: sectionInitialValues[SECTION_ADDRESSES] } : {}),
        }))
        setSaveMessage('')
        setLastSavedSection('')

    }

    const onProcess = async () => {
        if (hasAnyUnsavedChanges) {
            setProcessMessage("You have unsaved admin edits. Re-extracting from files may overwrite them. Continue?");
        } else {
            setProcessMessage("This will regenerate extracted data from the uploaded files and may overwrite admin corrections. Continue?");
        }

        setShowProcessModal(true);
        return;

    }






    const confirmProcess = async () => {
        try {
            setShowProcessModal(false);

            setBusy(true);
            getLoadingAlert(LOADING);
            setError('');
            setSaveMessage('');

            await apiProcessCase(applicationId);

            const refresh = async () => {
                try {
                    const res = await fetchCase(applicationId);
                    hydrateFromCase(res);

                    if (res.status === 'processing') {

                        setTimeout(refresh, 1500);
                    } else {

                        setBusy(false);
                        getLoadingAlert(HIDING);
                    }
                } catch (err) {
                    console.error("Refresh failed", err);
                    setBusy(false);
                    getLoadingAlert(HIDING);
                }
            };
            refresh();

        } catch (e) {
            console.error('Case process error', e);
            toast.error("Failed to start processing");
            setError('Failed to start processing');
            setBusy(false);
            getLoadingAlert(HIDING);
        }
    };



    const onDocFieldChange = (section, key, value) => {
        setEditFields((prev) => {
            const updated = {
                ...prev,
                [section]: {
                    ...(prev[section] || {}),
                    [key]: value,
                },
            };



            return updated;
        });

        setSaveMessage('');
    };

    const onAddressChange = (key, value) => {
        setEditFields((prev) => ({
            ...prev,
            addresses: {
                ...prev.addresses,
                [key]: value,
            },
        }))
        setSaveMessage('')
    }

    const onExtractedNameChange = (key, value) => {
        setEditFields((prev) => ({
            ...prev,
            extractedNames: {
                ...prev.extractedNames,
                [key]: value,
            },
        }))
        setSaveMessage('')
    }

    function sanitizeObject(obj) {
        return Object.fromEntries(
            Object.entries(obj || {}).map(([key, value]) => [key, typeof value === 'string' ? value.trim() : value || ''])
        )
    }

    const saveSection = async (section) => {
        if (!sectionDirty[section]) {
            setError('')
            setSaveMessage('')
            setEditingSection('')
            setLastSavedSection(section)
            return
        }

        try {
            setSavingEdits(true)
            setError('')
            setSaveMessage('')
            setLastSavedSection('')
            const payload = {
                docFields: sanitizeObject(section === SECTION_DOC1 ? editFields.docFields : sectionInitialValues[SECTION_DOC1]),
                docFields2: hasSecondId ? sanitizeObject(section === SECTION_DOC2 ? editFields.docFields2 : sectionInitialValues[SECTION_DOC2]) : null,
                addresses: sanitizeObject(section === SECTION_ADDRESSES ? editFields.addresses : sectionInitialValues[SECTION_ADDRESSES]),
                extractedNames: sanitizeObject(section === SECTION_BANK ? editFields.extractedNames : sectionInitialValues[SECTION_BANK]),
            }
            getLoadingAlert(LOADING);

            const res = await saveAdminFields(applicationId, payload)
            getLoadingAlert(HIDING);

            setData(res)
            setEditFields({
                docFields: normalizeDocFields(res?.docFields),
                docFields2: normalizeDocFields(res?.docFields2),
                addresses: normalizeAddresses(res?.addresses),
                extractedNames: normalizeExtractedNames(res?.extractedNames),
            })
            setEditingSection('')
            setLastSavedSection(section)
            setSaveMessage('Section saved')
        } catch (e) {
            getLoadingAlert(HIDING);

            console.error('Admin edit save error', e)
            toast.error(e?.message || 'Failed to save admin edits');

            setError(e?.message || 'Failed to save admin edits')
        } finally {
            setSavingEdits(false)
        }
    }


    const loadAssessment = (assessment) => {
        const nextAnswers = assessment?.answers || {}
        setAnswers(nextAnswers)
        setScores(assessment?.scores || null)
        setUpdatedAt(assessment?.updatedAt || null)
        setActiveAssessmentId(assessment?.assessmentId || '')
        if (schema) calcLocal(nextAnswers)
    }



    const handleSubmit = async () => {
        if (!isChecked) {
            toast.error("Please provide your authorization to submit the Risk Assessment.");
            return;
        }

        try {
            getLoadingAlert(LOADING);

            const response = await axios.patch(
                `${base_url}investor-master/update_risk_assessment`,
                {
                    investor_kyc_id: investor_kyc_id,
                    risk_assessment_completed: 'true'
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            );


            // toast.success("Risk Assessment completed successfully");

            await goToAdminDashboardSuccess();
            getLoadingAlert(HIDING)
        } catch (error) {
            getLoadingAlert(HIDING)

            console.error("Error:", error);

            toast.error("Failed to submit Risk details");

        }


    };

    const handleCancel = () => {
        setIsChecked(false);
    };


    const parseDate = (dateStr) => {
        if (!dateStr) return null;
        const [day, month, year] = dateStr.split("/");
        return new Date(`${year}-${month}-${day}`);
    };

    const dobValue = editFields.docFields?.dob;
    const dobValueSecond = editFields.docFields2?.dob;


    return (
        <>
            <div>
                <AdminNavBarMain />



                <div className="row admin_body_main position-static bg-transparent" >
                    <div className="d-flex justify-content-between align-items-center">

                        {/* Left Side */}
                        <div className="col d-flex align-items-center my-xxl-2 my-lg-1">
                            <h5
                                className="admin_serv d-flex align-items-center mb-0"
                                onClick={() => goToAdminDashboard(true)}
                                style={{ cursor: "pointer" }}
                            >
                                <img
                                    src="/images/left_arrow.svg"
                                    alt="left"
                                    className="indiv_loan_dtls"
                                />
                                &nbsp; Back to Investor Details
                            </h5>
                        </div>

                        {/* Right Side Buttons */}
                        <div className="d-flex gap-2">
                            {(() => {
                                const base = EKYC_BASE_URL;
                                const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

                                return (
                                    <>


                                        <a
                                            className="case_action_btn btn-sm"
                                            href={`${base}/ekyc/case/${applicationId}/export.csv?tz=${encodeURIComponent(timezone)}`}
                                            download
                                        >
                                            ↓ Download CSV
                                        </a>

                                        <a
                                            className="case_action_btn btn-sm"
                                            href={`${base}/ekyc/case/${applicationId}/report?print=1&tz=${encodeURIComponent(timezone)}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Open PDF Report
                                        </a>
                                    </>
                                );
                            })()}
                        </div>

                    </div>
                </div>


                <GlobalLoader show={enableSweetAlert} />


                <div className="">
                    <div
                        className="tab-content idiv_inv_left_card_text pe-5 ps-5"
                        id="myTabContent"

                    >

                        <div className="ekyc-layout">

                            {/* LEFT COLUMN */}
                            <div className="ekyc-left">

                                <div className="section-header">

                                    {/* TOP ROW */}
                                    <div className="ekyc-header-row">
                                        <div className="section-title blue">EKYC DETAILS</div>

                                        <div className="section-right">

                                            {data?.canProcess !== false && data?.status === 'processing' && <button className="case-btn" disabled>Processing…</button>}
                                            {data?.status !== 'processing' && (
                                                <>
                                                    <button className="case-btn" onClick={onProcess} disabled={busy || data?.canProcess === false
                                                        || Number(kycStatus) === COMPLIANCE_APPROVED} title={data?.canProcess === false ? 'Unavailable for DB-only cases' : 'Reprocess'}>
                                                        {busy ? 'Reprocessing…' : 'Reprocess'}
                                                    </button>


                                                    <span
                                                        data-tooltip-id="bank=tooltip"
                                                        data-tooltip-place="top"
                                                        data-tooltip-offset={8}
                                                        data-tooltip-position-strategy="fixed"
                                                        className="pep-info-icon"
                                                    > i
                                                    </span>
                                                    <Tooltip
                                                        id="bank=tooltip"
                                                        place="top"
                                                        className="pep-tooltip"
                                                    >
                                                        Reprocess runs extraction again from the original
                                                        uploaded files.It may overwrite admin-corrected
                                                        extracted fields like ID details, bank statement
                                                        name, and addresses.
                                                    </Tooltip>
                                                </>
                                            )}



                                        </div>
                                    </div>

                                    {/* FULL WIDTH LINE */}
                                    <div className="section-line blue"></div>

                                </div>



                                <div className="card-ekyc">

                                    {/* Header */}
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            gap: 12,
                                            flexWrap: 'wrap'
                                        }}
                                    >
                                        <div className="section-title-ekyc">
                                            First ID - {data?.idType} - Document Fields
                                        </div>

                                        <div style={{ display: 'flex', gap: 8 }}>
                                            {isSectionEditing(SECTION_DOC1) ? (
                                                <>
                                                    <button
                                                        className="ekyc-reset-btn"
                                                        onClick={() => resetSection(SECTION_DOC1)}
                                                        disabled={savingEdits && editingSection === SECTION_DOC1}
                                                    >
                                                        Reset
                                                    </button>

                                                    <button
                                                        className="upload-btn"
                                                        onClick={() => saveSection(SECTION_DOC1)}
                                                        disabled={savingEdits && editingSection === SECTION_DOC1}
                                                    >
                                                        {savingEdits && editingSection === SECTION_DOC1
                                                            ? 'Saving…'
                                                            : 'Save'}
                                                    </button>
                                                </>
                                            ) : (
                                                <button
                                                    className="upload-btn"
                                                    onClick={() => enterEditMode(SECTION_DOC1)}
                                                    disabled={data?.status === 'processing' || Number(kycStatus) === COMPLIANCE_APPROVED}
                                                >
                                                    Edit
                                                </button>
                                            )}
                                        </div>
                                    </div>

                                    <div className="button-group-ekyc"></div>




                                    <div className="form-grid">
                                        {DOC_FIELD_CONFIG.map((field) => {
                                            const f = editFields.docFields || {};
                                            const displayValue = f[field.key] ?? "";

                                            return (
                                                <div key={field.key} className="form-group">
                                                    <label>{field.label}</label>

                                                    {isSectionEditing(SECTION_DOC1) ? (
                                                        field.key === "dob" || field.key === "expiry" ? (
                                                            <Flatpickr
                                                                value={displayValue}
                                                                options={{
                                                                    dateFormat: "d/m/Y",
                                                                    allowInput: true,
                                                                    monthSelectorType: "dropdown",
                                                                    yearSelectorType: "dropdown",
                                                                    ...(field.key === "dob"
                                                                        ? { maxDate: "today" }
                                                                        : {
                                                                            minDate: dobValue ? parseDate(dobValue) : "today"
                                                                        })
                                                                }}
                                                                onChange={(selectedDates, dateStr) =>
                                                                    onDocFieldChange("docFields", field.key, dateStr)
                                                                }
                                                                className={`form-control bg-white }`}
                                                            />
                                                        ) : (
                                                            <input
                                                                value={displayValue}
                                                                onChange={(e) =>
                                                                    onDocFieldChange("docFields", field.key, e.target.value)
                                                                }
                                                            />
                                                        )
                                                    ) : (
                                                        <div className="form-value">{displayValue || "-"}</div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>


                                {hasSecondId && (
                                    <div className="card-ekyc">

                                        {/* Header */}
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                gap: 12,
                                                flexWrap: 'wrap'
                                            }}
                                        >
                                            <div className="section-title-ekyc">
                                                Second ID - {data?.formFields?.idType2} - Document Fields
                                            </div>

                                            <div style={{ display: 'flex', gap: 8 }}>
                                                {isSectionEditing(SECTION_DOC2) ? (
                                                    <>
                                                        <button
                                                            className="ekyc-reset-btn"
                                                            onClick={() => resetSection(SECTION_DOC2)}
                                                            disabled={savingEdits && editingSection === SECTION_DOC2}
                                                        >
                                                            Reset
                                                        </button>

                                                        <button
                                                            className="upload-btn"
                                                            onClick={() => saveSection(SECTION_DOC2)}
                                                            disabled={savingEdits && editingSection === SECTION_DOC2}
                                                        >
                                                            {savingEdits && editingSection === SECTION_DOC2
                                                                ? 'Saving…'
                                                                : 'Save'}
                                                        </button>
                                                    </>
                                                ) : (
                                                    <button
                                                        className="upload-btn"
                                                        onClick={() => enterEditMode(SECTION_DOC2)}
                                                        disabled={data?.status === 'processing' || Number(kycStatus) === COMPLIANCE_APPROVED}
                                                    >
                                                        Edit
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                        <div className="button-group-ekyc"></div>

                                        <div className="form-grid">
                                            {DOC_FIELD_CONFIG.map((field) => {
                                                const f = editFields.docFields2 || {};
                                                const displayValue = f[field.key] ?? "";

                                                return (
                                                    <div key={field.key} className="form-group">
                                                        <label>{field.label}</label>

                                                        {isSectionEditing(SECTION_DOC2) ? (
                                                            field.key === "dob" || field.key === "expiry" ? (
                                                                <Flatpickr
                                                                    value={displayValue}
                                                                    options={{
                                                                        dateFormat: "d/m/Y",
                                                                        allowInput: true,
                                                                        monthSelectorType: "dropdown",
                                                                        yearSelectorType: "dropdown",
                                                                        ...(field.key === "dob"
                                                                            ? { maxDate: "today" }   // DOB → past only
                                                                            : {
                                                                                minDate: dobValueSecond ? parseDate(dobValueSecond) : "today"
                                                                            })
                                                                    }}
                                                                    onChange={(selectedDates, dateStr) =>
                                                                        onDocFieldChange("docFields2", field.key, dateStr)
                                                                    }
                                                                    className={`form-control bg-white }`}
                                                                />
                                                            ) : (
                                                                <input
                                                                    value={displayValue}
                                                                    onChange={(e) =>
                                                                        onDocFieldChange("docFields2", field.key, e.target.value)
                                                                    }
                                                                />
                                                            )
                                                        ) : (
                                                            <div className="form-value">{displayValue || "-"}</div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}







                                <div className="card-ekyc">

                                    {/* Header */}
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            gap: 12,
                                            flexWrap: 'wrap'
                                        }}
                                    >
                                        <div className="section-title-ekyc">
                                            Bank Statement - Extracted Details
                                        </div>

                                        <div style={{ display: 'flex', gap: 8 }}>
                                            {isSectionEditing(SECTION_BANK) ? (
                                                <>
                                                    <button
                                                        className="ekyc-reset-btn"
                                                        onClick={() => resetSection(SECTION_BANK)}
                                                        disabled={savingEdits && editingSection === SECTION_BANK}
                                                    >
                                                        Reset
                                                    </button>

                                                    <button
                                                        className="upload-btn"
                                                        onClick={() => saveSection(SECTION_BANK)}
                                                        disabled={savingEdits && editingSection === SECTION_BANK}
                                                    >
                                                        {savingEdits && editingSection === SECTION_BANK
                                                            ? 'Saving…'
                                                            : 'Save'}
                                                    </button>
                                                </>
                                            ) : (
                                                <button
                                                    className="upload-btn"
                                                    onClick={() => enterEditMode(SECTION_BANK)}
                                                    disabled={data?.status === 'processing' || Number(kycStatus) === COMPLIANCE_APPROVED}
                                                >
                                                    Edit
                                                </button>
                                            )}
                                        </div>
                                    </div>

                                    <div className="button-group-ekyc"></div>



                                    <div style={{ marginTop: 12 }} className="form-group">
                                        <label>Extracted Bank Passbook Name</label>
                                        {isSectionEditing(SECTION_BANK) ? (
                                            <input value={editFields.extractedNames.bankStatement || ''}
                                                onChange={(e) => onExtractedNameChange('bankStatement', e.target.value)}
                                            />
                                        ) : (
                                            <div className="form-value">
                                                {editFields.extractedNames.bankStatement || '-'}
                                            </div>
                                        )}
                                    </div>
                                </div>



                                <div className="card-ekyc">

                                    {/* Header */}
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            gap: 12,
                                            flexWrap: 'wrap'
                                        }}
                                    >
                                        <div className="section-title-ekyc">
                                            Addresses
                                        </div>

                                        <div style={{ display: 'flex', gap: 8 }}>
                                            {isSectionEditing(SECTION_ADDRESSES) ? (
                                                <>
                                                    <button
                                                        className="ekyc-reset-btn"
                                                        onClick={() => resetSection(SECTION_ADDRESSES)}
                                                        disabled={savingEdits && editingSection === SECTION_ADDRESSES}
                                                    >
                                                        Reset
                                                    </button>

                                                    <button
                                                        className="upload-btn"
                                                        onClick={() => saveSection(SECTION_ADDRESSES)}
                                                        disabled={savingEdits && editingSection === SECTION_ADDRESSES}
                                                    >
                                                        {savingEdits && editingSection === SECTION_ADDRESSES
                                                            ? 'Saving…'
                                                            : 'Save'}
                                                    </button>
                                                </>
                                            ) : (
                                                <button
                                                    className="upload-btn"
                                                    onClick={() => enterEditMode(SECTION_ADDRESSES)}
                                                    disabled={data?.status === 'processing' || Number(kycStatus) === COMPLIANCE_APPROVED}
                                                >
                                                    Edit
                                                </button>
                                            )}
                                        </div>
                                    </div>

                                    <div className="button-group-ekyc"></div>





                                    <div className="form-grid">
                                        {ADDRESS_CONFIG.map((field) => (
                                            <div key={field.key} className="form-group">
                                                <label >{field.label}</label>
                                                {isSectionEditing(SECTION_ADDRESSES) ? (
                                                    <textarea
                                                        rows={5}
                                                        value={editFields.addresses[field.key] || ''}
                                                        onChange={(e) => onAddressChange(field.key, e.target.value)}
                                                        className="ekyc-textarea"
                                                    />
                                                ) : (
                                                    <div className="form-value"
                                                        style={{ minHeight: 116, whiteSpace: 'pre-wrap', cursor: 'default' }}
                                                    >
                                                        {editFields.addresses[field.key] || '-'}
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>


                                </div>








                                <div className="card-ekyc">
                                    <div className="section-title-ekyc">User Entered Details</div>
                                    <div className="button-group-ekyc"></div>

                                    <div className="details-grid">
                                        <div className="label">Full Name</div>
                                        <div className="value">{data?.formFields?.fullName || '-'}</div>

                                        <div className="label">Country</div>
                                        <div className="value">{data?.formFields?.country || '-'}</div>

                                        <div className="label">ID Number</div>
                                        <div className="value">{data?.formFields?.idNumber || '-'}</div>

                                        <div className="label">ID Type</div>
                                        <div className="value">{data?.idType || '-'}</div>
                                    </div>
                                </div>

                                <div className="card-ekyc">
                                    <div className="section-title-ekyc">Biometrics & Status</div>
                                    <div className="button-group-ekyc"></div>

                                    <table className="table-ekyc" style={{ margin: 0 }}>
                                        <tbody>




                                            <tr className="table-section">
                                                <th colSpan="3">Document Verification</th>
                                            </tr>



                                            {(() => {
                                                const tag = (v) =>
                                                    v === true
                                                        ? "tag tag-success"
                                                        : v === false
                                                            ? "tag tag-danger"
                                                            : "tag tag-warning";

                                                const txt = (v) =>
                                                    v === true
                                                        ? "Identical"
                                                        : v === false
                                                            ? "Mismatch"
                                                            : "Required field missing";

                                                return verificationRows1.map((row) => (
                                                    <tr key={row.key}>
                                                        <th>{row.label}</th>
                                                        <td>
                                                            <span className={tag(row.value)}>
                                                                {txt(row.value)}
                                                            </span>

                                                            {row.message && (
                                                                <div className="helper-text">
                                                                    {row.message}
                                                                </div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ));
                                            })()}


                                            <tr className="table-section">
                                                <th colSpan="3">Face Match</th>
                                            </tr>

                                            {faceMatch ? (
                                                (() => {
                                                    const hasScore =
                                                        typeof faceMatch?.score === "number" &&
                                                        !Number.isNaN(Number(faceMatch?.score));



                                                    const statusText =
                                                        faceMatch?.passed === true
                                                            ? "Identical"
                                                            : faceMatch?.passed === false && faceMatch?.error
                                                                ? "Required file missing"
                                                                : faceMatch?.passed === false
                                                                    ? "Does not match"
                                                                    : "-";

                                                    const statusClass =
                                                        faceMatch?.passed === true
                                                            ? "tag tag-success"
                                                            : faceMatch?.passed === false
                                                                ? faceMatch?.error
                                                                    ? "tag tag-warning" //  missing files
                                                                    : "tag tag-danger"  // mismatch
                                                                : "tag";
                                                    return (
                                                        <>


                                                            <tr>
                                                                <th>Result</th>
                                                                <td>
                                                                    <span className={statusClass}>{statusText}</span>

                                                                    {faceMatch?.error && (
                                                                        <div className="helper-text">
                                                                            {faceMatch.error}
                                                                        </div>
                                                                    )}
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <th>Backend</th>
                                                                <td>
                                                                    {hasScore ? (
                                                                        <span className={faceMatch.passed ? "tag tag-success" : "tag"}>
                                                                            {String(faceMatch.score)}
                                                                        </span>
                                                                    ) : (
                                                                        "-"
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        </>
                                                    );
                                                })()
                                            ) : (
                                                <tr>
                                                    <td colSpan="3" className="muted">
                                                        Pending
                                                    </td>
                                                </tr>
                                            )}

                                            <tr className="table-section">
                                                <th colSpan="3">Liveness</th>
                                            </tr>

                                            {liveness ? (
                                                <>
                                                    {liveness.mode && (
                                                        <tr>
                                                            <th>Mode</th>
                                                            <td>{liveness.mode}</td>
                                                        </tr>
                                                    )}

                                                    {liveness.decision && (
                                                        <tr>
                                                            <th>Decision</th>
                                                            <td>
                                                                <span
                                                                    className={
                                                                        liveness.passed ? "tag tag-success" : "tag tag-danger"
                                                                    }
                                                                >
                                                                    {String(liveness.decision)}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    )}

                                                    {liveness.raw && liveness.raw.results && Array.isArray(liveness.raw.results.attempts) && liveness.raw.results.attempts.length > 0 && (

                                                        <tr>
                                                            <th>Attempt status</th>
                                                            <td>
                                                                <span className="tag">
                                                                    {
                                                                        liveness.raw.results.attempts[
                                                                            liveness.raw.results.attempts.length - 1
                                                                        ].attemptStatus
                                                                    }
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </>
                                            ) : (
                                                <tr>
                                                    <td className="muted">Not provided</td>
                                                </tr>
                                            )}

                                        </tbody>
                                    </table>
                                </div>

                                <div className="card-ekyc">
                                    <div className="section-title-ekyc">Evidence</div>
                                    <div className="button-group-ekyc"></div>

                                    {(() => {
                                        if (artifactEntries.length === 0) return <div className="muted">No artifacts</div>
                                        return (
                                            <div style={{ display: 'grid', gap: 16 }}>
                                                {uploadedArtifactEntries.length > 0 && (
                                                    <div>
                                                        <div className="muted" style={{ marginBottom: 10 }}>Uploaded Files</div>
                                                        <ArtifactGrid entries={uploadedArtifactEntries} data={data} onOpenViewer={setViewer} />
                                                    </div>
                                                )}
                                                {generatedArtifactEntries.length > 0 && (
                                                    <div>
                                                        <div className="muted" style={{ marginBottom: 10 }}>Generated Processing Files</div>
                                                        <ArtifactGrid entries={generatedArtifactEntries} data={data} onOpenViewer={setViewer} />
                                                    </div>
                                                )}
                                            </div>
                                        )
                                    })()}

                                </div>
                            </div>

                            {/* RIGHT COLUMN */}
                            <div className="ekyc-right">
                                <div className="section-header">

                                    <div className="ekyc-header-row">
                                        <div className="section-title orange">RISK ASSESSMENT</div>

                                        {/* Empty right section to balance height */}
                                        <div className="section-right-risk">



                                        </div>
                                    </div>

                                    <div className="section-line orange"></div>

                                </div>







                                <div className="card-ekyc">
                                    <div className="section-title-ekyc">Risk Questions</div>
                                    <div className="button-group-ekyc"></div>
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th style={{ width: '45%', fontWeight: '600', color: '#212529' }}>Question</th>
                                                <th style={{ fontWeight: '600', color: '#212529' }}>Drop Down</th>
                                                <th style={{ width: '120px', fontWeight: '600', color: '#212529' }}>Score</th>
                                            </tr>
                                        </thead>


                                        <tbody>
                                            {rows.map(q => (
                                                <tr key={q.id}>
                                                    <td>{q.label}</td>
                                                    <td>
                                                        {

                                                            q.lookup && lookups?.[q.lookup] ? (
                                                                <select value={answers[q.id] || ''} onChange={(e) => { onChange(q.id, e.target.value) }}
                                                                    className="select"

                                                                >
                                                                    <option value="">Select…</option>
                                                                    {Object.keys(lookups[q.lookup] || {}).filter(k => k !== 'default').map(k => (
                                                                        <option key={k} value={k}>{k}</option>
                                                                    ))}
                                                                </select>
                                                            ) : (
                                                                <select value={answers[q.id] || ''} onChange={(e) => { onChange(q.id, e.target.value) }}
                                                                    className="select"

                                                                >
                                                                    <option value="">Select…</option>
                                                                    {(q.options || []).map(o => (
                                                                        <option key={o.value} value={o.value}>{o.label}</option>
                                                                    ))}
                                                                </select>
                                                            )}
                                                    </td>
                                                    <td><ScoreCell value={q._score} /></td>
                                                </tr>
                                            ))}
                                            <tr>
                                                <td colSpan={2}><strong>Total Score</strong></td>
                                                <td><strong>{scores?.total ?? 0}</strong></td>
                                            </tr>


                                        </tbody>




                                    </table>

                                    <div className="risk-summary-row">

                                        <div className="risk-left">
                                            <strong>Risk Level</strong>
                                            <span className="risk-score">
                                                {scores ? (
                                                    <span className={scores.band === 'High'
                                                        ? 'tag tag-danger'
                                                        : scores.band === 'Medium'
                                                            ? 'tag tag-warn'
                                                            : 'tag tag-success'}>
                                                        {scores.band}
                                                    </span>
                                                ) : '-'}
                                            </span>
                                        </div>

                                        <div className="risk-right">




                                            <a
                                                className="case_action_btn btn-sm"
                                                href={`${EKYC_BASE_URL}/ekyc/case/${applicationId}/risk/export.csv`}
                                                download
                                            >
                                                Export CSV
                                            </a>


                                            <button className="ekyc-primary-btn" onClick={onSaveRisk}
                                                disabled={saving || !isAllAnswered}
                                            >{saving ? 'Saving…' : 'Save Assessment'}</button>


                                        </div>

                                    </div>


                                </div>


                                <div className="card-ekyc">
                                    <div className="section-title-ekyc">Previous Assessments</div>
                                    <div className="button-group-ekyc"></div>

                                    <div className="assessment-list">


                                        {assessments.length === 0 && (
                                            <div className="muted">No saved assessments yet.</div>)}


                                        <div className="grid" style={{ gap: 10 }}>
                                            {assessments.map((assessment, index) => {
                                                const href = `${EKYC_BASE_URL}/ekyc/case/${applicationId}/risk/export.csv?assessmentId=${encodeURIComponent(assessment.assessmentId)}`
                                                const isActive = activeAssessmentId && activeAssessmentId === assessment.assessmentId
                                                return (
                                                    <div
                                                        key={assessment.assessmentId || `${assessment.updatedAt}-${index}`}
                                                        className="risk-assessment-item"
                                                        style={{
                                                            borderColor: isActive ? 'var(--brand)' : undefined,
                                                            boxShadow: isActive ? '0 0 0 1px var(--brand) inset' : undefined,
                                                        }}
                                                    >
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, alignItems: 'flex-start' }}>
                                                            <div style={{ minWidth: 0 }}>
                                                                <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                                                                    {/* <strong>{`Assessment ${index + 1}`}</strong> */}
                                                                    <strong>{`Assessment ${assessment.assessmentNumber}`}</strong>
                                                                    <span className={riskBandClass(assessment?.scores?.band)}>{assessment?.scores?.band || 'Unknown'}</span>
                                                                    <span className="badge">Score {assessment?.scores?.total ?? 0}</span>
                                                                </div>
                                                                <div className="muted" style={{ marginTop: 6 }}>
                                                                    {formatSavedAt(assessment.updatedAt)} · {assessment.investorName || applicationId}
                                                                </div>
                                                            </div>
                                                            <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
                                                                <button
                                                                    type="button"
                                                                    className="icon-btn"
                                                                    onClick={() => {
                                                                        const url = `${EKYC_BASE_URL}/ekyc/case/${applicationId}/risk/preview?assessmentId=${assessment.assessmentId}`;
                                                                        window.open(url, "_blank");
                                                                    }}
                                                                    title="View assessment"
                                                                >
                                                                    <EyeIcon />
                                                                </button>
                                                                <a className="btn btn-secondary" href={href}>
                                                                    Export CSV
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>

                                    </div>
                                </div>



                                {!riskCompleted && (
                                    <div className="approval-card">

                                        <div className="approval-header">
                                            <span className="approval-icon">✅</span>
                                            <span className="approval-title">Approval Decision</span>

                                        </div>
                                        <div className="button-group-ekyc"></div>



                                        <div className="approval-body">

                                            <label className="approval-checkbox">
                                                <input
                                                    type="checkbox"
                                                    checked={isChecked}
                                                    onChange={(e) => setIsChecked(e.target.checked)}
                                                />
                                                Risk Assessment Completed
                                            </label>




                                            <div className="approval-actions">
                                                <button className="btn btn_background px-3 py-2"
                                                    onClick={handleCancel}>Cancel</button>
                                                {/* <button className="btn mx-2 py-2 px-3"
                                                style={{ backgroundColor: "#ED5151", color: "white" }}>Reject</button> */}
                                                <button className="btn blue_btn me-3 px-4 py-2"
                                                    onClick={handleSubmit}
                                                    disabled={!isChecked || assessments.length === 0} >Submit</button>
                                            </div>


                                        </div>


                                    </div>
                                )}



                            </div>

                        </div>

                    </div>
                </div>
            </div>


            <Lightbox open={viewer.open} src={viewer.src} title={viewer.title} onClose={() => setViewer({ open: false, src: '', title: '' })} />



            <Modal
                show={showConfirmModal}
                onHide={() => setShowConfirmModal(false)}
                centered
                backdrop="static"
                keyboard={false}
            >
                <Modal.Body className="text-center p-4">

                    {/* <h5 className="fw-bold mb-2">Unsaved Changes</h5> */}

                    <div className="alert_modal">
                        You have unsaved changes in the current section.
                        Do you want to discard them and continue?
                    </div>

                    <div className="p-2 d-flex justify-content-center gap-3 mt-3">

                        <button

                            className="btn btn_background px-3 py-2"

                            onClick={() => {
                                setShowConfirmModal(false);
                                setNextSection(null);
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            className="btn blue_btn me-3 px-4 py-2"
                            onClick={() => {
                                setEditFields((prev) => ({
                                    ...prev,
                                    ...(editingSection === SECTION_DOC1 ? { docFields: sectionInitialValues[SECTION_DOC1] } : {}),
                                    ...(editingSection === SECTION_DOC2 ? { docFields2: sectionInitialValues[SECTION_DOC2] } : {}),
                                    ...(editingSection === SECTION_BANK ? { extractedNames: sectionInitialValues[SECTION_BANK] } : {}),
                                    ...(editingSection === SECTION_ADDRESSES ? { addresses: sectionInitialValues[SECTION_ADDRESSES] } : {}),
                                }));

                                setSaveMessage('');
                                setLastSavedSection('');
                                setEditingSection(nextSection);

                                setShowConfirmModal(false);
                                setNextSection(null);
                            }}
                        >
                            OK
                        </button>


                    </div>

                </Modal.Body>
            </Modal>


            <Modal
                show={showProcessModal}
                onHide={() => setShowProcessModal(false)}
                centered
                backdrop="static"
                keyboard={false}
            >
                <Modal.Body className="text-center p-4">

                    <h5 className="fw-bold mb-2">Confirm Reprocess</h5>

                    <div className="alert_modal">
                        {processMessage}
                    </div>

                    <div className="d-flex justify-content-center gap-3 mt-3">
                        <button
                            className="btn btn_background px-3 py-2"
                            onClick={() => setShowProcessModal(false)}
                        >
                            Cancel
                        </button>
                        <button
                            className="btn blue_btn me-3 px-4 py-2"
                            onClick={confirmProcess}
                        >
                            OK
                        </button>


                    </div>

                </Modal.Body>
            </Modal>
        </>



    );




};

export default EKYCDetailsView;


export function artifactUrl(url) {
    const API_BASE = EKYC_BASE_URL
    if (!url) return url
    if (/^https?:\/\//i.test(url)) return url
    return `${API_BASE}${url}`
}












